import React from 'react';

import {
  DEFAULT_HEIGHT,
  DEFAULT_WIDTH,
  VisualizationSequenceSummary,
} from 'molbio/components/visualizations/SequenceVisualizationConstants';

import CircularFragmentVisualization from './CircularFragmentVisualization';
import LinearFragmentVisualization from './LinearFragmentVisualization';

const WIDTH_HEIGHT_RATIO = DEFAULT_HEIGHT / DEFAULT_WIDTH;

export default function FragmentVisualization({
  sequence,
  fragmentColor,
  width = DEFAULT_WIDTH,
}: {
  sequence: VisualizationSequenceSummary;
  fragmentColor: string;
  width?: number;
}): JSX.Element {
  const height = width * WIDTH_HEIGHT_RATIO;
  if (sequence.circular) {
    return (
      <CircularFragmentVisualization
        sequence={sequence}
        fragmentColor={fragmentColor}
        width={width}
        height={height}
      />
    );
  } else {
    return (
      <LinearFragmentVisualization
        sequence={sequence}
        fragmentColor={fragmentColor}
        width={width}
        height={height}
      />
    );
  }
}
